import DataTable from 'datatables.net-react';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import ReactDOMServer from 'react-dom/server';
import { FaFilter } from 'react-icons/fa'; // Import an icon for the button
import Select from 'react-select';
import Swal from 'sweetalert2';
import { TradeService } from '../../services/tradeService';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from '../components/AdminDropdown';
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import { customStyles, the } from '../components/customStyles';
import From from '../components/From';
import MarketDropdown from '../components/MarketDropdown';
import MasterDropdown from '../components/MasterDropdown';
import NumberFormatter from "../components/NumberFormatter";
import ScriptDropdown from '../components/ScriptDropdown';
import To from '../components/To';
import '../custom.css';
import { useLocation } from "react-router-dom";

function Trademobile() {

    const location = useLocation();
    const { page } = location.state || {};
    const [trade, setTrade] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [selectedMaster, setSelectedMaster] = useState(null);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedMarket, setSelectedMarket] = useState(null);
    const [selectedScript, setSelectedScript] = useState(null);
    const [selectedOrderType, setSelectedOrderType] = useState(null);
    const [status, setStatus] = useState(page && page === 'executed' ? 'EXECUTED' : page === 'pending' ? 'PENDING' : 'EXECUTED');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedBrokerId, setSelectedBrokerId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedTrade, setSelectedTrade] = useState(null);
    const [modalType, setModalType] = useState(null);
    const [showModalExecuted, setShowModalExecuted] = useState(false);
    const [selectedTradeExecuted, setSelectedTradeExecuted] = useState(null);
    const [modalTypeExecuted, setModalTypeExecuted] = useState(null);
    const [showModalFilter, setShowModalFilter] = useState(false);

    var user = BullCache.getFromCache("user");

    const handleModalShowFilter = () => {
        setShowModalFilter(true);
        setSelectedMarket(null);
    };
    const handleModalCloseFilter = () => setShowModalFilter(false);


    const openModalForTrade = (tradeData) => {
        setSelectedTrade({ ...tradeData });
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };
    const handleUpdate = () => {
        const updatedTrade = {
            orderId: selectedTrade.orderId || null,
            orderType: selectedTrade.orderType || null,
            quantity: selectedTrade.quantity || null,
            lot: selectedTrade.lot || null,
            rate: selectedTrade.rate || null,
            scriptId: selectedTrade.scriptId || null,
            adminId: user.adminId || null,
            device: selectedTrade.device || null,
            remark: selectedTrade.remark || null,
        };


        TradeService.editTable(updatedTrade)
            .then((resp) => {
                if (resp.code === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Updated Successfully !",
                    })
                    handleManualRefresh();
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Something went to wrong!",
                    })
                }
            })
            .catch((error) => {
                console.error("Error updating trade data:", error);
            });

        handleClose();
    };


    useEffect(() => {
        const icons = document.querySelectorAll('.icon-pencil');
        icons.forEach((icon) => {
            icon.addEventListener('click', handleEditClick);
        });

        return () => {
            icons.forEach((icon) => {
                icon.removeEventListener('click', handleEditClick);
            });
        };
    }, [trade]);

    const handleEditClick = (event) => {
        const target = event.target.classList.contains('icon-pencil') ? event.target : event.target.closest('.icon-pencil');
        const tradeData = JSON.parse(decodeURIComponent(target.getAttribute('data-full')));

        if (tradeData.status === 'PENDING') {
            setModalType('PENDING');
        } else if (tradeData.status === 'EXECUTED') {
            setModalType('EXECUTED');
        }

        openModalForTrade(tradeData);
    };


    const openModalForTradeExecuted = (tradeData) => {
        setSelectedTradeExecuted({ ...tradeData });
        setShowModalExecuted(true);
    };

    const handleCloseExecuted = () => {
        setShowModalExecuted(false);
    };
    const handleUpdateExecuted = () => {
        const updatedTrade = {
            orderId: selectedTradeExecuted.executedOrderId || null,
            quantity: selectedTradeExecuted.quantity || null,
            lot: selectedTradeExecuted.lot || null,
            rate: selectedTradeExecuted.rate || null,
            adminId: user.adminId || null,
            device: selectedTradeExecuted.device || null,
            remark: selectedTradeExecuted.remark || null,
        };


        TradeService.editTableExecuted(updatedTrade)
            .then((resp) => {
                if (resp.code === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Updated Successfully !",
                    })
                    handleManualRefresh();
                } else {
                     Swal.fire({
                        icon: "error",
                        text: resp.messages || "Something went to wrong!",
                    })
                }
            })
            .catch((error) => {
                console.error("Error updating trade data:", error);
            });

        handleCloseExecuted();
    };



    const handleDeleteClickExecuted = (event) => {
        const target = event.target.classList.contains('icon-trash') ? event.target : event.target.closest('.icon-trash');
        const orderIdToDelete = target.getAttribute('data-id');
        const tradeData = JSON.parse(decodeURIComponent(target.getAttribute('data-full')));

        const deleteRequestData = {
            orderId: tradeData.orderId || orderIdToDelete,
            adminId: user.adminId || null,
            device: tradeData.device || null,
            remark: tradeData.remark || null,
        };
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to delete this trade?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {

                if (tradeData.executedOrderId) {

                    TradeService.deleteDataExecuted(deleteRequestData)
                        .then((resp) => {
                            if (resp.code === 1) {
                                setTrade((prevTrades) => prevTrades.filter((trade) => trade.orderId !== orderIdToDelete));

                                Swal.fire({
                                    icon: "success",
                                    text: "Deleted Successfully !",
                                })
                                handleManualRefresh();

                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: "Something Went to wrong !",
                                })
                            }
                        })
                        .catch((error) => {
                            console.error('Error deleting trade:', error);
                        });
                } else {
                    TradeService.deleteData(deleteRequestData)
                        .then((resp) => {
                            if (resp.code === 1) {
                                setTrade((prevTrades) => prevTrades.filter((trade) => trade.orderId !== orderIdToDelete));

                                Swal.fire({
                                    icon: "success",
                                    text: "Deleted Successfully !",
                                })
                                handleManualRefresh();
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: "Something Went to wrong !",
                                })
                            }
                        })
                        .catch((error) => {
                            console.error('Error deleting trade:', error);
                        });
                }
            } else {
                Swal.fire({
                    icon: "warning",
                    text: "Something Went to wrong !",
                })
            }
        });

    };
    // };

    useEffect(() => {
        const deleteIcons = document.querySelectorAll('.icon-trash');

        deleteIcons.forEach((icon) => {
            icon.addEventListener('click', handleDeleteClickExecuted);
        });

        return () => {
            deleteIcons.forEach((icon) => {
                icon.removeEventListener('click', handleDeleteClickExecuted);
            });
        };
    }, [trade]);

    useEffect(() => {
        const icons = document.querySelectorAll('.icon-pencil');
        icons.forEach((icon) => {
            icon.addEventListener('click', handleEditClickExecuted);
        });

        return () => {
            icons.forEach((icon) => {
                icon.removeEventListener('click', handleEditClickExecuted);
            });
        };
    }, [trade]);

    const handleEditClickExecuted = (event) => {
        const target = event.target.classList.contains('icon-pencil') ? event.target : event.target.closest('.icon-pencil');
        const tradeData = JSON.parse(decodeURIComponent(target.getAttribute('data-full')));

        if (tradeData.status === 'PENDING') {
            setModalTypeExecuted('PENDING');
        } else if (tradeData.status === 'EXECUTED') {
            setModalTypeExecuted('EXECUTED');
        }

        openModalForTradeExecuted(tradeData);
    };


    const [calledFirstTime, setCalledFirstTime] = useState(false);

    var user = BullCache.getFromCache("user");
    var allScripts = BullCache.getFromCache("allScripts");

    useEffect(() => {
        if (!calledFirstTime) {
            
            const dataToSubmit = {
                adminId: user.adminId,
                status,
                segment: selectedMarket,
                keyword: selectedScript,
                date: fromDate,
                endDate: toDate,
            };
            fetchData(dataToSubmit);
            setCalledFirstTime(true);
        }
    }, [fromDate, toDate]);

    const fetchData = (dataToSubmit) => {
        TradeService.tradeSearch(dataToSubmit)
            .then((resp) => {
 
                if (resp.code === 1 && resp.data.trades.length > 0) {
                    setTrade(resp.data.trades);

                } else {
                    setTrade([]);
                }
            })
            .catch((error) => { });
    };
    const handleManualRefresh = () => {
        const dataToSubmit = {
            adminId: user.adminId,
            status,
            segment: selectedMarket,
            keyword: selectedScript,
            date: fromDate,
            endDate: toDate,
        };
        fetchData(dataToSubmit); // Manually trigger fetchData from the custom hook
    };

    const handleMarketChange = (market) => {
        setSelectedMarket(market);
    };

    const handleScriptChange = (script) => {
        setSelectedScript(script);
    };
    const handleScriptReset = () => {
        setSelectedScript(null);
    };


    const handleFromDateChange = (newDate) => {
        setFromDate(newDate);
    };
    const handleToDateChange = (newDate) => {
        setToDate(newDate);
    };

    const handleSelectedClientChange = (selected) => {
        setSelectedClient(selected?.userId);
    };

    const handleOrderTypeChange = (selectedOption) => {
        setSelectedOrderType(selectedOption);
    };
    const option = [
        { value: 'market', label: ' Market' },
        { value: 'limit', label: 'Limit' },
    ];



    function getDeviceIcon(device) {
        return device != undefined ? (device == 'Browser' ? '../../../img/web.png' : device == 'IOS' ? '../../../img/iphone.png' : '../../../img/phone.png') : '../../../img/phone.png';
    }

    const [columns, setColumns] = useState([
        {
          title: "D",
          render: (data, type, full, meta) =>
            '<img style="filter: invert(1) brightness(0);" height="12px" width="12px" src="' + getDeviceIcon(full.device) + '" class="icon"/>',
        },
        { title: 'TRADE BY', data: 'tradeBy', className: "text-nowrap page-wrapper"  },
        { title: 'O-TIME', data: 'orderTime', className: "text-nowrap page-wrapper"  },
         { title: 'E-TIME', data: 'executedDate', className: "text-nowrap page-wrapper"  },
        { title: 'NAME', data: 'userName', className: "page-wrapper" },
        { title: 'MARKET', data: 'orderType',
            render: (data, type, full, meta) => full.orderType.toUpperCase()
         },
        { title: 'SYMBOL', data: 'symbol' },
        {
          title: 'TYPE',
          render: (data, type, full, meta) => {
            return full.orderType.startsWith('Buy') ? 'B' : 'S';
          },
        },
        { title: 'LOT', data: 'lot' },
        { title: 'QTY', data: 'quantity' },
        {
          title: 'O-PRICE', 
          data: 'rate', 
          render: (data, type, full, meta) =>
            ReactDOMServer.renderToString(<NumberFormatter number={full.rate} />),
        },
        {
          title: 'NET PRICE', className: "text-nowrap page-wrapper", 
          render: (data, type, full, meta) =>
            ReactDOMServer.renderToString(<NumberFormatter number={full.netRate != null ? full.netRate : full.rate} />),
        },
        ...((status === 'PENDING' || status === 'CANCELLED') || (user.adminType === 'SUPER_ADMIN' && status === 'EXECUTED')
          ? [{
            title: 'MODIFY',
            render: (data, type, full, meta) => {
              const orderId = full.status === 'PENDING' ? full.orderId : full.executedOrderId;
              return `
                <i class="me-3 fa fa-pencil icon-pencil" data-id="${orderId}" data-full='${encodeURIComponent(JSON.stringify(full))}' style="cursor: pointer"></i>
              `;
            },
          }]
          : []),
        {
          title: 'CANCEL',
          render: (data, type, full, meta) => {
            const orderId = full.status === 'PENDING' ? full.orderId : full.executedOrderId;
      
            if (!orderId) return null;
      
            return `
              <i class="icon-trash fa fa-trash" 
                  data-id="${orderId}"  
                  data-full='${encodeURIComponent(JSON.stringify(full))}' 
                  style="cursor: pointer; color: red">
              </i>
            `;
          },
        },
        { 
          title: 'STATUS', 
          data: 'status' 
        },
        { 
          title: 'IP', 
          render: (data, type, full, meta) => {
            const ip = full.ip;
            if (!ip) return null; // If there's no IP, return null (nothing to display)
      
            // Create the anchor tag for the IP
            return `<a href="https://whatismyipaddress.com/ip/${ip}" target="_blank">${ip}</a>`;
          },
        },
      ]);
      
    const initializeColumn = () => {
        if (user?.adminType !== 'SUPER_ADMIN' && status === 'EXECUTED') {
            setColumns((prevColumns) =>
                prevColumns.filter((col) => col.title !== 'MODIFY' && col.title !== 'CANCEL')
            );
        }
    }

    useEffect(() => {
        initializeColumn();
    }, [status]);



    const options = {
        paging: true,
        searching: true,
        responsive: true,
        select: true,
        columnDefs: [
            {
                targets: 1, width: '10%', createdCell: (cell) => {
                  cell.style.whiteSpace = 'nowrap';
                }
              },
              {
                targets: 2, width: '10%', createdCell: (cell) => {
                  cell.style.whiteSpace = 'nowrap';
                }
              },
              {
                targets: 3, width: '10%', createdCell: (cell) => {
                  cell.style.whiteSpace = 'nowrap';
                }
              },
               {
                targets: 4, width: '10%', createdCell: (cell) => {
                  cell.style.whiteSpace = 'nowrap';
                }
              },
              {
                targets: 5, width: '10%', createdCell: (cell) => {
                  cell.style.whiteSpace = 'nowrap';
                }
              },
              {
                targets: 6, width: '15%', createdCell: (cell) => {
                  cell.style.whiteSpace = 'nowrap';
                }
              }
        ]
    };
    const handleSubmit = () => {
        const dataToSubmit = {
            adminId: user.adminId,
            status: status,
            segment: selectedMarket,
            keyword: selectedScript,
            date: fromDate,
            endDate: toDate
        };


        if (selectedClient) {
            dataToSubmit.userId = selectedClient;
            dataToSubmit.adminId = user.adminId;
        } else if (selectedSubBrokerId) {
            dataToSubmit.adminId = selectedSubBrokerId.value;
        } else if (selectedBrokerId) {
            dataToSubmit.adminId = selectedBrokerId;
        } else if (selectedMaster) {
            dataToSubmit.adminId = selectedMaster.value;
        } else if (selectedAdmin) {
            dataToSubmit.adminId = selectedAdmin.value;
        }



        TradeService.tradeSearch(dataToSubmit)
            .then((resp) => {
                handleModalCloseFilter();
                if (resp.code === 1) {
                    if (resp.data.trades.length > 0) {
                        setTrade(resp.data.trades);
                    } else {
                        setTrade([]);
                    }
                } else {
                    setTrade([]);
                }
            }).catch((error) => {

            });

    };

    return (

        <div className='ps-1 pe-1'>
            <Row className='mt-2 mb-1'>
                <Col className="h6 text-start">FILTER</Col>

                <Col className="text-end">
                    <Button variant="link" onClick={handleModalShowFilter} className="p-0">
                        <FaFilter size={20} />
                    </Button>
                </Col>
            </Row>


            <Modal show={showModalFilter} onHide={handleModalCloseFilter} size="sm">
                <Modal.Header closeButton>
                    <Modal.Title>FILTER</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Card className='mt-2'>
                        <Card.Body>
                            <Row>
                                <Col>

                                    {['radio'].map((type) => (
                                        <div key={`inline-${type}`}>
                                            <Form.Check
                                                inline
                                                label="PENDING "
                                                className='h6 fss-05'
                                                name="group1"
                                                type={type}
                                                id={`inline-${type}-1`}
                                                checked={status === 'PENDING'}
                                                onChange={() => setStatus('PENDING')}

                                            />
                                        </div>
                                    ))}


                                    <div>
                                        {['radio'].map((type) => (
                                            <div key={`inline-${type}`}>
                                                <Form.Check
                                                    defaultChecked
                                                    inline
                                                    className='h6 fss-05'
                                                    label="EXECUTED "
                                                    name="group1"
                                                    type={type}
                                                    id={`inline-${type}-1`}
                                                    checked={status === 'EXECUTED'}
                                                    onChange={() => setStatus('EXECUTED')}
                                                />
                                            </div>
                                        ))}
                                    </div>



                                    <div>
                                        {['radio'].map((type) => (
                                            <div key={`inline-${type}`}>
                                                <Form.Check
                                                    inline
                                                    className='h6 fss-05'
                                                    label="ADMIN DELETED "
                                                    name="group1"
                                                    type={type}
                                                    id={`inline-${type}-1`}
                                                    checked={status === 'CANCELLED'}
                                                    onChange={() => setStatus('CANCELLED')}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </Col>



                                <Col>
                                    <b className='fss-05'>FROM</b><br />
                                    <From fromDate={fromDate} onDateChange={handleFromDateChange} /> <br />

                                    <b className='fss-05'>TO</b><br />
                                    <To toDate={toDate} setToDate={handleToDateChange} />
                                </Col>
                            </Row>


                            <Col  >
                                <b className='fss-05'>MARKET</b>
                                <MarketDropdown allScripts={allScripts} onMarketChange={handleMarketChange} onScriptReset={handleScriptReset}

                                />
                            </Col>

                            <Col >
                                <b className='fss-05'>SCRIPT NAME</b>
                                <ScriptDropdown
                                    allScripts={allScripts}
                                    selectedMarket={selectedMarket}
                                    onScriptChange={handleScriptChange}
                                />

                            </Col>
                            <Col  >
                                <b className='fss-05'>ORDER TYPE</b>
                                <Select
                                    options={option}
                                    value={selectedOrderType}
                                    onChange={handleOrderTypeChange}
                                    className='text-black'
                                    placeholder="Select"
                                    isSearchable={true}
                                    theme={the} styles={customStyles}
                                    isClearable
                                />                </Col>



                            {/* <Row> */}
                            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
                                <>
                                    <Col >
                                        <b className="fss-05">ADMIN</b>
                                        <AdminDropdown
                                            adminId={user.adminId}
                                            setSelectedOption={setSelectedAdmin} />
                                    </Col>
                                </> : ""}

                            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
                                <>
                                    <Col >
                                        <b className="fss-05">MASTER</b>
                                        <MasterDropdown
                                            adminId={user.adminId}
                                            selectedAdmin={selectedAdmin}
                                            setSelectedOption={setSelectedMaster}
                                            setSelectedMaster={setSelectedMaster}
                                            setSelectedBrokerId={setSelectedBrokerId}

                                        />
                                    </Col>
                                </> : ""}

                            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'SUPER_MASTER' ?
                                <>
                                    <Col >
                                        <b className="fss-05">BROKER</b>
                                        <BrokerDropdown
                                            selectedAdmin={selectedAdmin}
                                            selectedMaster={selectedMaster}
                                            setSelectedOption={setSelectedBrokerId}
                                            setSelectedBrokerId={setSelectedBrokerId}
                                            setSelectedSubBrokerId={setSelectedSubBrokerId}
                                        />
                                    </Col>
                                </> : ""}



                            <Col  >
                                <b className="fss-05">CLIENT</b>
                                <ClientDropdown
                                    selectedAdmin={selectedAdmin}
                                    selectedMaster={selectedMaster}
                                    selectedBrokerId={selectedBrokerId}
                                    setSelectedOption={handleSelectedClientChange}
                                />

                            </Col>
                            {/* </Row> */}

                            <Col className='mt-4 '>
                                <Button variant="success" size="sm" className='me-1' onClick={handleSubmit}>
                                    <b className='h6 small'> Find Trade</b>
                                </Button>

                                <Button variant="secondary" size="sm" className='me-1'>
                                    <b className='h6 small'>Clear Search</b>
                                </Button>

                                <Button variant="secondary" size="sm">
                                    <b className='h6 small'>Export</b>
                                </Button>
                            </Col>


                        </Card.Body>
                    </Card >
                </Modal.Body>
            </Modal>

            {modalType === 'PENDING' && (
                <div>
                    <Modal show={showModal} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className="modal-title-center">Trade Details</Modal.Title>

                        </Modal.Header>
                        <Modal.Body>

                            {selectedTrade ? (
                                <>

                                    <Row >
                                        <Col xs={12} className='mt-1' >
                                            <Row>
                                                <Col xs={4}>
                                                    <b className='fss-06 me-2'>NAME :</b>
                                                </Col>

                                                <Col>
                                                    <b className='fss-06'> {selectedTrade.userName} </b>
                                                </Col>
                                            </Row>

                                            <Row className=''>
                                                <Col xs={4}>
                                                    <b className='fss-06'>SYMBOL :</b>
                                                </Col>
                                                <Col>
                                                    <b className='fss-06'>{selectedTrade.symbol}</b>
                                                </Col>
                                            </Row>

                                        </Col>

                                        <Col xs={12}>
                                            <Row className='mt-2'>
                                                <Col xs={4}>
                                                    <b className='fss-06'>LOT :</b>
                                                </Col>
                                                <Col xs={8}>
                                                    <input
                                                        type="number"
                                                        value={selectedTrade.lot || ''}
                                                        onChange={(e) =>
                                                            setSelectedTrade((prevState) => ({
                                                                ...prevState,
                                                                lot: e.target.value,
                                                            }))
                                                        }
                                                        className="form-control fss-05 bg-light text-black"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className='mt-2'>
                                                <Col xs={4}>
                                                    <b className='fss-06'>QTY :</b>
                                                </Col>
                                                <Col xs={8}>
                                                    <input
                                                        type="number"
                                                        value={selectedTrade.quantity || ''}
                                                        onChange={(e) =>
                                                            setSelectedTrade((prevState) => ({
                                                                ...prevState,
                                                                quantity: e.target.value,
                                                            }))
                                                        }
                                                        className="form-control fss-05 bg-light text-black"
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>  
                                        <Col xs={12}>
                                            <Row className='mt-2'>
                                                <Col xs={4}>
                                                    <b className='fss-06'>ORDER PRICE </b>
                                                </Col>
                                                <Col xs={8}>
                                                    <input
                                                        type="number"
                                                        value={selectedTrade.rate || ''}
                                                        onChange={(e) =>
                                                            setSelectedTrade((prevState) => ({
                                                                ...prevState,
                                                                rate: e.target.value,
                                                            }))
                                                        }
                                                        className="form-control fss-05 bg-light text-black"
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="">
                                        <Col xs={4}>
                                            <b className='fss-07'>Remark:</b>
                                        </Col>
                                        <Col xs={8}>
                                            <Form.Control
                                                type="text"
                                                className="mt-2  text-black bg-white custom-placeholder fss-05"
                                                placeholder="Remark"
                                                name="remark"
                                            />
                                        </Col>
                                    </Row>
                                </>
                            ) : ''}
                        </Modal.Body>
                        <Modal.Footer className="d-flex justify-content-center">
                            <Button variant="success" size='sm' onClick={handleUpdate}>
                                Update
                            </Button>
                            <Button variant="danger" size='sm' onClick={handleClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </div>
            )}


            {modalType === 'EXECUTED' && (
                <div>
                    <Modal show={showModalExecuted} onHide={handleCloseExecuted}>
                        <Modal.Header closeButton>
                            <Modal.Title className="modal-title-center">Trade Details</Modal.Title>

                        </Modal.Header>
                        <Modal.Body>

                            {selectedTradeExecuted ? (
                                <>
                                    <Row >
                                        <Col sm={6} className='mt-1' >
                                            <Row>
                                                <Col sm={5}>
                                                    <b className='fss-06 me-2'>NAME :</b>
                                                </Col>

                                                <Col>
                                                    <b className='fss-05'> {selectedTradeExecuted.userName} </b>
                                                </Col>
                                            </Row>

                                            <Row className='mt-1'>
                                                <Col sm={5}>
                                                    <b className='fss-06  '>ORDER TYPE :</b>
                                                </Col>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        className="fss-05 me-4"
                                                        name="orderType"
                                                        type="radio"
                                                        id="buyOrder"
                                                        label="Buy"
                                                        checked={selectedTradeExecuted.orderType.includes('Buy')}
                                                        onChange={() =>
                                                            setSelectedTradeExecuted((prevState) => ({
                                                                ...prevState,
                                                                orderType: prevState.orderType.startsWith('Sell')
                                                                    ? 'Buy' + prevState.orderType.split('-')[1]
                                                                    : 'Buy',
                                                            }))
                                                        }
                                                    />

                                                    <Form.Check
                                                        inline
                                                        className="fss-05"
                                                        name="orderType"
                                                        type="radio"
                                                        id="sellOrder"
                                                        label="Sell"
                                                        checked={selectedTradeExecuted.orderType.includes('Sell')}
                                                        onChange={() =>
                                                            setSelectedTradeExecuted((prevState) => ({
                                                                ...prevState,
                                                                orderType: prevState.orderType.startsWith('Buy')
                                                                    ? 'Sell' + prevState.orderType.split('-')[1]
                                                                    : 'Sell',
                                                            }))
                                                        }
                                                    />

                                                </Col> </Row>
                                            <Row className=''>
                                                <Col sm={4}>
                                                    <b className='fss-06 '>TYPE :</b>
                                                </Col>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        className="fss-05 me-2"
                                                        style={{ marginLeft: 21 }}
                                                        name="market"
                                                        type="radio"
                                                        id="marketOrder"
                                                        label="Market"
                                                        checked={selectedTradeExecuted.orderType === 'Buy-MP' || selectedTradeExecuted.orderType === 'Sell-MP'}
                                                        onChange={() =>
                                                            setSelectedTradeExecuted((prevState) => ({
                                                                ...prevState,
                                                                orderType: prevState.orderType.startsWith('Buy')
                                                                    ? 'Buy-MP'
                                                                    : prevState.orderType.startsWith('Sell')
                                                                        ? 'Sell-MP'
                                                                        : prevState.orderType,
                                                            }))
                                                        }
                                                    />

                                                    <Form.Check
                                                        inline
                                                        className="fss-05"
                                                        name="market"
                                                        type="radio"
                                                        id="limitOrder"
                                                        label="Limit"
                                                        checked={selectedTradeExecuted.orderType === 'Buy-SL' || selectedTradeExecuted.orderType === 'Sell-SL'} // Check if selected market type is 'Limit'
                                                        onChange={() =>
                                                            setSelectedTradeExecuted((prevState) => ({
                                                                ...prevState,
                                                                orderType: prevState.orderType.startsWith('Buy')
                                                                    ? 'Buy-SL'
                                                                    : prevState.orderType.startsWith('Sell')
                                                                        ? 'Sell-SL'
                                                                        : prevState.orderType,
                                                            }))
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className=''>
                                                <Col sm={5}>
                                                    <b className='fss-06'>SYMBOL :</b>
                                                </Col>
                                                <Col>
                                                    <b className='fss-05'>{selectedTradeExecuted.symbol}</b>
                                                </Col>
                                            </Row>

                                        </Col>

                                        <Col sm={6}>
                                            <Row>
                                                <Col sm={3}>
                                                    <b className='fss-06'>LOT :</b>
                                                </Col>
                                                <Col>
                                                    <input
                                                        type="number"
                                                        value={selectedTradeExecuted.lot || ''}
                                                        onChange={(e) =>
                                                            setSelectedTradeExecuted((prevState) => ({
                                                                ...prevState,
                                                                lot: e.target.value,
                                                            }))
                                                        }
                                                        className="form-control fss-05 bg-light text-black"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className='mt-2'>
                                                <Col sm={3}>
                                                    <b className='fss-06'>QTY :</b>
                                                </Col>
                                                <Col>
                                                    <input
                                                        type="number"
                                                        value={selectedTradeExecuted.quantity || ''}
                                                        onChange={(e) =>
                                                            setSelectedTradeExecuted((prevState) => ({
                                                                ...prevState,
                                                                quantity: e.target.value,
                                                            }))
                                                        }
                                                        className="form-control fss-05 bg-light text-black"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className='mt-2'>
                                                <Col sm={3}>
                                                    <b className='fss-06'>ORDER PRICE </b>
                                                </Col>
                                                <Col>
                                                    <input
                                                        type="number"
                                                        value={selectedTradeExecuted.rate || ''}
                                                        onChange={(e) =>
                                                            setSelectedTradeExecuted((prevState) => ({
                                                                ...prevState,
                                                                rate: e.target.value,
                                                            }))
                                                        }
                                                        className="form-control fss-05 bg-light text-black"
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="">
                                        <Col sm={2}>
                                            <b className='fss-07'>Remark:</b>
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                className="mt-2  text-black bg-white custom-placeholder fss-05"
                                                placeholder="Remark"
                                                name="remark"
                                            />
                                        </Col>
                                    </Row>
                                </>
                            ) : ''}
                        </Modal.Body>
                        <Modal.Footer className="d-flex justify-content-center">
                            <Button variant="success" size='sm' onClick={handleUpdateExecuted}>
                                Update
                            </Button>
                            <Button variant="danger" size='sm' onClick={handleCloseExecuted}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            )}

            <Card className='mt-1'>
                <Card.Body className='mb-5 p-0'>
                    <div className="table-responsive">
                        <DataTable
                            id="table"
                            key={columns.length}
                            className="mt-1 table table-striped text-center bg-secondary-row fss-08 table th "
                            data={trade}
                            options={{
                                ...options,
                                language: {
                                    emptyTable: 'No Data Found',
                                    lengthMenu: '_MENU_',
                                },
                                dom: '<"datatable-toolbar"lf>rtip',
                                rowCallback: function (row, data) {
                                    if (data.type === 'B') {
                                        $(row).addClass('buy-row');
                                    }
                                    if (data.type === 'S') {
                                        $(row).addClass('sell-row');
                                    }
                                }
                            }}
                            columns={columns}

                        />
                    </div>
                </Card.Body>
            </Card>

        </div>
    );
}
export default Trademobile;